import 'leaflet/dist/leaflet.css'

import './vue/contracts'
import './pages'
import './plugins/gtmdatalayer'
import './vue/time-table'
import './vue/upcoming-table'
import './vue/cart'

const bsCustomFileInput = require('bs-custom-file-input')
const $ = require('jquery')
const { sanitize } = require('dompurify')
const moment = require('moment')
const validator = require('email-validator')
require('daterangepicker')

import('../../src/js/components/video-light-gallery.js')
require('bootstrap-select')
require('bootstrap-select/dist/js/i18n/defaults-nl_NL')
require('bootstrap-select/sass/bootstrap-select.scss')
require('./plugins/fullcalendar')
require('./plugins/gtmdatalayer')
require('owl.carousel')

;(function () {
  // ===================
  // Rental scheduler
  // ===================
  const rentalSchedulerSelector = '#rental-scheduler'
  if (document.querySelector(rentalSchedulerSelector)) {
    import('./vue/rental-scheduler').then(({ default: mount }) => { mount(rentalSchedulerSelector) })
  }

  // ===================
  // Moments modal
  // ===================
  const momentsModalElements = document.querySelectorAll('#moment-modal')
  momentsModalElements.forEach(element => {
    import('./vue/moments-modal').then(({ default: mount }) => { mount(element) })
  })

  $('a[data-activity-id]').on('click', (e) => {
    const activityId = $(e.target).data('activity-id')
    $('.modal[data-activity-id="' + activityId + '"]').modal('show')
  })

  // ===================
  // Timetable
  // ===================
  if (document.getElementById('timetable')) {
    import('./vue/time-table').then(({ default: mount }) => { mount(document.getElementById('timetable')) })
  }

  // ===================
  // Upcoming Table
  // ===================
  if (document.getElementById('upcoming-table')) {
    import('./vue/upcoming-table').then(({ default: mount }) => { mount(document.getElementById('upcoming-table')) })
  }
})()

$(function () {
  bsCustomFileInput.init()

  // eslint-disable-next-line no-undef
  if (typeof CAPTCHA_KEY !== 'undefined' && CAPTCHA_KEY) {
    $('form.js-captcha').find(':submit').prop('disabled', false)
  }

  // Trigger timeout after page is loaded in case recaptcha is not validated yet
  window.onload = function () {
    setTimeout(function () {
      $('form.js-captcha').find(':submit').prop('disabled', false)
    }, 2000)
  }

  // ===================
  // Ticket upsell carousel
  // ===================
  $(document).ready(function () {
    $('.upsell .owl-carousel').owlCarousel({
      loop: false,
      nav: true,
      dots: false,
      navText: [
        '<btn class="btn-sm btn-link"><i class=\'fa fa-fw fa-chevron-left mr-2\'></i>Terug</btn>',
        '<btn class="btn-sm btn-link">Toon meer<i class=\'fa fa-fw fa-chevron-right ml-2\'></i></btn>'
      ],
      autoplay: false,
      mouseDrag: false,
      items: 1
    })
  })

  // ===================
  // Scroll to element
  // ===================
  $('.scroll-element').on('click', function (e) {
    e.preventDefault()
    const targetId = $(this).attr('href')
    $('html, body').animate({
      scrollTop: $(targetId).offset().top
    }, 500)
  })

  // ===================
  // Dropdown menu websites
  // ===================
  $(document).ready(function () {
    $('.dropdown-menu a.dropdown-toggle').on('click', function (e) {
      if (!$(this).next().hasClass('show')) {
        $(this).parents('.dropdown-menu').first().find('.show').removeClass('show')
      }
      const $subMenu = $(this).next('.sub-dropdown')
      $subMenu.toggleClass('show')

      $(this).parents('li.nav-item.dropdown.show').on('hidden.bs.dropdown', function (e) {
        $('.dropdown-submenu .show').removeClass('show')
      })

      return false
    })
  })

  // ===================
  // Daterange picker
  // ===================
  const dateRangeSearchParams = new URLSearchParams(window.location.search)
  const startDate = dateRangeSearchParams.get('start') ? dateRangeSearchParams.get('start') : moment()
  let endDate
  if (dateRangeSearchParams.get('end') === 'today') {
    endDate = moment()
  } else {
    endDate = dateRangeSearchParams.get('end') ? dateRangeSearchParams.get('end') : moment().startOf('day').add(6, 'days')
  }
  $('input[name="dates"]').daterangepicker({
    locale: {
      format: 'DD-MM-YYYY',
      separator: ' t/m ',
      applyLabel: 'Toepassen',
      cancelLabel: 'Annuleren',
      fromLabel: 'Van',
      toLabel: 'Tot en met',
      customRangeLabel: 'Aangepast',
      weekLabel: 'W',
      daysOfWeek: [
        'Zo',
        'Ma',
        'Di',
        'Wo',
        'Do',
        'Vr',
        'Za'
      ],
      monthNames: [
        'Januari',
        'Februari',
        'Maart',
        'April',
        'Mei',
        'Juni',
        'Juli',
        'Augustus',
        'September',
        'Oktober',
        'November',
        'December'
      ],
      firstDay: 1
    },
    startDate,
    endDate,
    ranges: {
      Vandaag: [moment(), moment()],
      'Komende 7 dagen': [moment(), moment().add(6, 'days')],
      'Komende maand': [moment(), moment().add(1, 'month').subtract(1, 'day')],
      'Volgende week': [moment().add(1, 'week').startOf('isoWeek'), moment().add(1, 'week').endOf('isoWeek')]
    }

  }, function (start, end, label) {
    if ('URLSearchParams' in window) {
      const selectedRangeStart = start.format('DD-MM-YYYY')
      const selectedRangeEnd = end.format('DD-MM-YYYY')
      dateRangeSearchParams.set('start', selectedRangeStart)
      dateRangeSearchParams.set('end', selectedRangeEnd)
      window.location.search = dateRangeSearchParams.toString()
    }
  })

  $('select.schedule-input').each(function (index) {
    $(this).on('change', function (e) {
      e.preventDefault()
      dateRangeSearchParams.set($(this).attr('name'), $(this).val())
      window.location.search = dateRangeSearchParams.toString()
    })
  })

  // ===================
  // FUNCTIONS
  // ===================
  function buildCalendarModal ($modal) {
    $modal.modal()

    $modal.on('hidden.bs.modal', function (e) {
      $(this).data('bs.modal', null)
      $modal.remove()
    })

    const $targetForm = $modal.find('form')
    const initialFormData = new FormData($targetForm[0])

    // When ActivityID is pre-filtered, disable (and automatically hide) invalid options
    // E.g. when using PICK_TIME from products overview
    if (initialFormData.get('ActivityID')) {
      $targetForm.find('[name=ActivityID] option').each(function () {
        const $option = $(this)
        if (!$option.data('activityIds').split(',').includes(initialFormData.get('ActivityID'))) {
          $option.prop('disabled', true)
        }
      })
    }

    $modal.find('[data-toggle=popover]').popover()

    $modal.on('shown.bs.modal', function () {
      $modal.find('.selectpicker').selectpicker()

      $modal.find('.js-calendar').calendar({
        aspectRatio: 1,
        eventClick: ({ event, el, jsEvent, view }) => {
          jsEvent.preventDefault()

          const $dateDisplay = $targetForm.find('[data-connect=SubscriptionAgendaDisplay]')

          if ($(el).hasClass('active')) {
            $modal.find('.fc-event').removeClass('active inactive')
            $targetForm.find('[name=SubscriptionAgendaID]').val('')
            $targetForm.find('[name=WorkFlowStatus]').val('FINAL')
            $targetForm.find('#calendar-alert-container').hide()
            $targetForm.find('#calendar-alert').text('')

            $dateDisplay.text($dateDisplay.data('original-text'))
              .addClass('text-muted')

            $targetForm.find(':submit').prop('disabled', true)
            $targetForm.find('button[name="SUBMIT_SECONDARY"').show()
            $targetForm.find('button[name="SUBMIT_TERTIARY"').hide()
          } else {
            $modal.find('.fc-event').removeClass('active inactive')
            $targetForm.find('#calendar-alert-container').hide()
            $targetForm.find('#calendar-alert').text('')
            $(el).addClass('active')
            $modal.find('.fc-event:not(.active)').addClass('inactive')

            $targetForm.find('[name=SubscriptionAgendaID]').val(event.extendedProps.SubscriptionAgendaID)
            const wfs = event.extendedProps.workFlowStatus || ''
            $targetForm.find('[name=WorkFlowStatus]').val(wfs)
            if (wfs === 'DRAFT') {
              $targetForm.find('button[name="SUBMIT_SECONDARY"').hide()
              $targetForm.find('button[name="SUBMIT_TERTIARY"').show()
            }

            const alert = event.extendedProps.alert
            if (alert) {
              $targetForm.find('#calendar-alert').text(alert)
              $targetForm.find('#calendar-alert-container').show()
            }

            if (!$dateDisplay.data('original-text')) {
              $dateDisplay.data('original-text', $dateDisplay.text())
            }

            $dateDisplay.text(event.extendedProps.displayTitle || event.start.toLocaleString('nl-NL', {
              dateStyle: 'long',
              timeStyle: 'short'
            }) +
              ` (${event.extendedProps['Warehouse.Name'] || event.extendedProps.WarehouseID})`)
              .removeClass('text-muted')

            $targetForm.find(':submit').prop('disabled', false)

            const $modalBody = $(el).closest('.modal-body')
            const $modalDialog = $modalBody.closest('.modal-dialog')

            if ($modalDialog.hasClass('modal-dialog-scrollable')) {
              $modalBody.animate({ scrollTop: $modalBody.outerHeight() + 50 }, 500)
            } else {
              $modal.animate({ scrollTop: $modalDialog.outerHeight() + 50 }, 500)
            }
          }
        },
        loading (isLoading) {
          if (isLoading) {
            $('#loading-indicator').show(250)
          } else {
            $('#loading-indicator').hide(250)
          }
        }
      }, function (calendar) {
        setTimeout(function () {
          $modal.modal('handleUpdate')
        }, 1000)
      })
    })
  }

  function popoverClickHandler (e) {
    if ($('.popover.show').has(e.target).length === 0) {
      cartPopover.popover('hide')
    }
  }

  function autoCompleteAddress (e) {
    const zipcode = $('[data-address=\'zipcode\']').val()
    const houseNumber = $('[data-address$=\'house_number\']').val()

    if (zipcode && houseNumber) { // Only get data if zipcode and housenumber have a value
      getAddress(zipcode, houseNumber)
    }
  }

  function getAddress (zipcode, houseNr) {
    setAddressReadOnly(true)
    const formData = new FormData()

    formData.append('zipcode', zipcode)
    formData.append('houseNr', houseNr)

    const xhr = new XMLHttpRequest()
    xhr.open('POST', '/php/xhr/ajax.php?function=getAddress')
    xhr.send(formData)
    xhr.onload = function () {
      if (xhr.status === 200) {
        setAddress(JSON.parse(xhr.response))
      }
    }
    xhr.onloadend = function () {
      setAddressReadOnly(false)
    }
  }

  function setAddressReadOnly (toggle) {
    $('[data-address$=\'street\']').prop('readonly', toggle)
    $('[data-address$=\'city\']').prop('readonly', toggle)
  }

  function setAddress (xhrResponse) {
    $('[data-address$=\'street\']').val(xhrResponse.street)
    $('[data-address$=\'city\']').val(xhrResponse.city)
  }

  $('[data-address=\'zipcode\']').change(autoCompleteAddress)// ZIPCODE
  $('[data-address=\'house_number\']').change(autoCompleteAddress)// HOUSENUMBER

  // ===================
  // EMAIL CONFIRMATION IN SHOPPING CART FORM
  // ===================
  const validateEmailInputs = []

  if ($('input[type="email"]').length) {
    $('input[type="email"]').on('blur keyup', function (e) {
      const value = $(this).val()

      // When the input field is blurred, add email to array to validate on keydown.
      if (e.type === 'blur' && !validateEmailInputs.includes(e.target)) {
        validateEmailInputs.push(e.target)
      }

      // Set value to modal card (if exists)
      if ($('.validate-email-card').length) {
        $('.validate-email-card .email').text(value)
      }

      // Show card if value is not empty
      if (value.length) {
        if ($('.validate-email-card').length) {
          $('.validate-email-card').slideDown()
        }
      } else {
        $(this).removeClass('is-invalid is-valid') // remove success and error classes.
        validateEmailInputs.splice(validateEmailInputs.indexOf(e.target), 1) // remove input from arrays

        if ($('.validate-email-card').length) {
          $('.validate-email-card').slideUp()
        }
      }

      // check if input is in validateEmailInputs array and type is keydown
      if (validateEmailInputs.includes(e.target)) {
        // Check email validation and toggle class if neccessary.
        if (validator.validate(value)) {
          $(this).removeClass('is-invalid').addClass('is-valid')
        } else {
          $(this).removeClass('is-valid').addClass('is-invalid')
        }
      }
    })
  }

  // ===================
  // FORM VALIDATION
  // ===================
  $('form').on('submit', function (e) {
    const $currentForm = $(this)
    const currentFormId = $currentForm.attr('id')

    if (this.checkValidity() === false) {
      $currentForm.addClass('was-validated')
      return false
    }

    e.preventDefault()
    $currentForm.find('button[type="submit"]').prop('disabled', true)

    // Disable submit buttons outside the form
    $('button[type="submit"]').each(function () {
      const buttonFormId = $(this).closest('form').attr('id')
      if (buttonFormId !== currentFormId) {
        $(this).prop('disabled', true)
      }
    })

    // eslint-disable-next-line no-undef
    if ($currentForm.hasClass('js-captcha') && typeof CAPTCHA_KEY !== 'undefined' && CAPTCHA_KEY) {
      // eslint-disable-next-line no-undef
      grecaptcha.execute(CAPTCHA_KEY, { action: `Form/${$currentForm.attr('id')}`.replace(/[^A-Za-z/_]+/, '_') })
        .then(token => {
          $currentForm.prepend(`<input type="hidden" name="g-recaptcha-response" value="${token}">`)
          this.submit()
        })
        .catch(err => alert(err))
    } else {
      this.submit()
    }
  })

  // ===================
  // HAMBURGER --> BOOTSTRAP
  // ===================
  $('[data-toggle="collapse"].hamburger').click(function () {
    if ($(this).hasClass('collapsed')) {
      $(this).addClass('is-active')
    } else {
      $(this).removeClass('is-active')
    }
  })

  $('[data-toggle="tooltip"]').tooltip()

  // ===================
  // PART MODAL
  // ===================
  $('.js-show-part-modal').removeClass('disabled').click(function (e) {
    e.preventDefault()

    const tpl = $('#js-tpl-part-modal-' + $.escapeSelector($(this).data('part'))).html()
    const $modal = $(tpl)

    $('body').append($modal)

    $modal.modal()

    $modal.find('[data-toggle=popover]').popover()

    $modal.on('hidden.bs.modal', function (e) {
      $(this).data('bs.modal', null)
      $modal.remove()
    })
  })

  // ===================
  // cancel auto renewal modal
  // ===================

  $('.js-show-cancel-auto-renewal-modal').removeClass('disabled').on('click', function (e) {
    e.preventDefault()

    const tpl = $('#js-tpl-cancel-auto-renewal-modal-' + $.escapeSelector($(this).data('subscription'))).html()
    const $modal = $(tpl)

    $('body').append($modal)

    $modal.modal()

    $modal.find('[data-toggle=popover]').popover()

    $modal.on('hidden.bs.modal', function (e) {
      $(this).data('bs.modal', null)
      $modal.remove()
    })
  })

  // ===================
  // RESERVATION MODAL
  // ===================
  $('.js-show-reservation-modal').each(function () {
    const $btn = $(this)

    if ($btn.data('reservation-not-applicable')) return

    $btn.prop('disabled', false).click(function (e) {
      e.preventDefault()

      const tpl = $('#js-tpl-reservation-modal-' + $.escapeSelector($(this).data('subscription-agenda'))).html()
      const $modal = $(tpl)

      $('body').append($modal)

      $modal.modal()

      $modal.on('hidden.bs.modal', function (e) {
        $(this).data('bs.modal', null)
        $modal.remove()
      })
    })
  })

  // ===================
  // DISCOUNT CODE MODAL
  // ===================
  $('.js-show-discount-code-modal').removeClass('disabled').click(function (e) {
    e.preventDefault()

    const tpl = $('#js-tpl-discount-code-modal').html()
    const $modal = $(tpl)

    $modal.find('[name=DiscountCode]').keyup(function () {
      $(this).val($(this).val().toUpperCase())
    })

    $('body').append($modal)

    $modal.modal()

    $modal.on('shown.bs.modal', function () {
      $modal.find('[name=DiscountCode]').trigger('focus')
    })

    $modal.find('[data-toggle=popover]').popover()

    $modal.on('hidden.bs.modal', function () {
      $(this).data('bs.modal', null)
      $modal.remove()
    })
  })

  // ===================
  // REMOTE ACCESS
  // ===================

  $('.js-show-remote-access-modal').removeClass('disabled').click(function (e) {
    e.preventDefault()

    const $btn = $(this)
    const formData = new FormData()
    formData.append('time', $btn.data('time'))
    formData.append('subscriptionAgendaID', $btn.data('subscriptionAgenda'))

    const xhr = new XMLHttpRequest()
    xhr.open('POST', '/php/xhr/ajax.php?function=openSubscriptionAgendaDoors')
    xhr.send(formData)
    xhr.onreadystatechange = function () {
      if (xhr.readyState === XMLHttpRequest.DONE && xhr.status === 200) {
        const result = JSON.parse(xhr.responseText)
        const tpl = $('#js-tpl-remote-access-modal').html()
        const $modal = $(tpl)

        $('body').append($modal)

        const modalTitle = document.getElementById('remote-access--modal-title')

        modalTitle.innerHTML = result.message

        $modal.modal()

        $modal.find('[data-toggle=popover]').popover()

        $modal.on('hidden.bs.modal', function () {
          $(this).data('bs.modal', null)
          $modal.remove()
        })
      }
    }
  })

  // ===================
  // NEW GROUP MODAL
  // ===================
  $('.js-show-new-pag-modal').removeClass('disabled').click(function (e) {
    e.preventDefault()
    buildNewGroupModal($(this).data('subject'), { SubscribeYN: true })
  })

  function buildNewGroupModal (subject, params = {}, reloadAfter = true) {
    return new Promise(resolve => {
      const tpl = $('#js-tpl-new-pag-modal-' + $.escapeSelector(subject)).html()
      const $modal = $(tpl)

      $('body').append($modal)
      setTimeout(function () {
        $modal.css('z-index', parseInt($modal.css('z-index')) + 12)
        $modal.next('.modal-backdrop.show').css('z-index', $modal.css('z-index') - 1)
      })

      const groupRefreshParams = Object.assign({}, params)

      if (typeof params.PersonID === 'undefined' && typeof params.CustomerID === 'undefined') {
        const parsedSubject = subject.match(/^(.+)[:;,](.+)$/)
        if (parsedSubject) {
          groupRefreshParams[`${parsedSubject[1]}ID`] = parsedSubject[2]
        }
      }

      Object.keys(params).forEach(param => {
        if (params[param]) {
          $modal.find('form').prepend($(`<input type="hidden" name="${param}" value="${params[param]}"/>`))
        }
      })

      if (!reloadAfter) {
        $modal.find('form').data('skipReload', true)
      }

      refreshPersonGroups(
        $modal.find('form'),
        {
          BuyableYN: subject.match(/^Part[:;,]/) !== null,
          SubscribeYN: subject.match(/^Part[:;,]/) !== null,
          WarehouseID: $modal.find('[name=WarehouseID]').val() ?? null,
          ...groupRefreshParams
        }
      )

      $modal.modal()

      $modal.find('[data-toggle=popover]').popover()

      $modal.on('hidden.bs.modal', function () {
        $(this).data('bs.modal', null)
        $modal.remove()

        resolve(new FormData($modal.find('form')[0]))
      })
    })
  }

  // ===================
  // cancel reservation modal
  // ===================
  $('.js-show-cancellation-modal').removeClass('disabled').on('click', function (e) {
    e.preventDefault()

    const tpl = $('#js-tpl-cancellation-modal-' + $.escapeSelector($(this).data('subscription'))).html()
    const $modal = $(tpl)

    $('body').append($modal)

    $modal.modal()

    $modal.find('[data-toggle=popover]').popover()

    $modal.on('hidden.bs.modal', function (e) {
      $(this).data('bs.modal', null)
      $modal.remove()
    })
  })

  // ===================
  // toggle block wallet modal
  // ===================

  $('.js-show-toggle-block-wallet-modal').removeClass('disabled').click(function (e) {
    e.preventDefault()

    const tpl = $('#js-tpl-block-wallet-modal-' + $.escapeSelector($(this).data('wallet'))).html()
    const $modal = $(tpl)

    $('body').append($modal)

    $modal.modal()

    $modal.find('[data-toggle=popover]').popover()

    $modal.on('hidden.bs.modal', function (e) {
      $(this).data('bs.modal', null)
      $modal.remove()
    })
  })

  // ===================
  // PART CALENDAR MODAL
  // ===================
  $('.js-show-calendar-modal').removeClass('disabled').click(function (e) {
    e.preventDefault()

    const tpl = $('#js-tpl-calendar-modal-' + $.escapeSelector($(this).data('subscription'))).html()
    const $modal = $(tpl)

    // $modal.data('part', $(this).data('part'))
    $modal.data('subscription', $(this).data('subscription'))

    $('body').append($modal)

    buildCalendarModal($modal)
  })

  // ===================
  // UNSUBSCRIBE CONFIRMATION POPOVER
  // ===================

  $('.js-show-confirm-unsubscribe-modal').click(function (e) {
    e.preventDefault()

    const tpl = $('#js-tpl-confirm-unsubscribe-modal-' + $.escapeSelector($(this).data('pag'))).html()
    const $modal = $(tpl)

    $('body').append($modal)

    $modal.modal()

    $modal.find('[data-toggle=popover]').popover()

    $modal.on('hidden.bs.modal', function (e) {
      $(this).data('bs.modal', null)
      $modal.remove()
    })
  })

  // ===================
  // ITEM POPOVER
  // ===================

  let partID = ''
  const searchParams = new URLSearchParams(window.location.hash)
  for (const sp of searchParams) {
    if (sp[0] === '#PartID') {
      partID = sp[1]
    }
    if (sp[0] === '#added_to_cart') {
      partID = ''
      break
    }
  }

  if (partID !== '') {
    const itemPopover = $(this).find(`[data-part=${partID}]`)[0]
    if (itemPopover) {
      itemPopover.click()
    }
  }

  // ===================
  // CART POPOVER
  // ===================
  const cartPopover = $('[data-toggle="popover-cart"]')

  cartPopover.each(function () {
    const popover = $(this)
    popover.removeClass('disabled')

    const cartPopoverAutoTrigger = popover.data('auto-trigger')

    if (screen.width >= 576 || popover.data('sm')) { // Check $grid-breakpoints in ~bootstrap/scss/_variables.scss
      popover.popover({
        html: true,
        trigger: 'manual',
        placement: 'bottom',
        content: $(popover.data('target')).html(),
        sanitizeFn: sanitize
      })

      if (cartPopoverAutoTrigger && window.location.hash === `#${cartPopoverAutoTrigger}`) {
        const tpl = $('#js-tpl-added-to-cart-modal').html()
        const $modal = $(tpl)

        if (!$('#added-to-cart-modal').length) {
          $('body').append($modal)

          $modal.modal()

          $modal.find('[data-toggle=popover]').popover()

          $modal.on('hidden.bs.modal', function (e) {
            $(this).data('bs.modal', null)
            $modal.remove()
          })
        }
      }

      popover.click(function (e) {
        e.preventDefault()
        popover.popover('show')
      })

      popover.on('shown.bs.popover', function () {
        $(document).on('mouseup', popoverClickHandler)
      })

      popover.on('hide.bs.popover', function () {
        $(document).off('mouseup', popoverClickHandler)
        window.location.hash = window.location.hash.replace(cartPopoverAutoTrigger, '')
      })
    }
  })

  // ===================
  // ACTIVITY CONFIRM MODAL
  // ===================

  if (window.location.hash === '#added_to_activity') {
    const tpl = $('#js-tpl-added-to-activity-modal').html()
    const $modal = $(tpl)

    if (!$('#added-to-activity-modal').length) {
      $('body').append($modal)

      $modal.modal()

      $modal.find('[data-toggle=popover]').popover()

      $modal.on('hidden.bs.modal', function (e) {
        $(this).data('bs.modal', null)
        $modal.remove()
      })
    }
  }

  // ===================
  // MODAL BOM TIME
  // ===================

  function fetchBomTimes (RentDate, PartID, SubscriptionAgendaID) {
    setAddressReadOnly(true)
    const formData = new FormData()
    formData.append('RentDate', RentDate)
    formData.append('PartID', PartID)
    formData.append('SubscriptionAgendaID', SubscriptionAgendaID)

    const xhr = new XMLHttpRequest()
    xhr.open('POST', '/php/xhr/ajax.php?function=dataduiker/rental/availableForTarif')

    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4 && xhr.status === 200) {
        try {
          const response = JSON.parse(xhr.responseText)
          replaceTimeSlotHTML(response)
        } catch (error) {
          alert(error)
        }
      }
    }

    xhr.send(formData)
  }

  // Function to replace the time slot HTML
  function replaceTimeSlotHTML (response) {
    const timeSlotContainer = document.getElementById('timepick')

    timeSlotContainer.innerHTML = ''

    if (Object.keys(response).length === 0) {
      // If no time slots found, display a message
      const noResultsMessage = document.createElement('div')
      noResultsMessage.className = 'no-time-slots-message'
      noResultsMessage.textContent = 'No available time slots found for the selected date.'
      timeSlotContainer.appendChild(noResultsMessage)
      return
    }

    Object.keys(response).forEach((time, index) => {
      const formattedTime = time.slice(0, 5)

      const label = document.createElement('label')
      label.className = 'px-lg-2 col-md-3 col-sm-4 col-6'
      label.setAttribute('for', `ShoppingCartForm-SelectTimeSlot-RentTime-${index}`)

      const input = document.createElement('input')
      input.className = 'd-none card-input-element'
      input.setAttribute('id', `ShoppingCartForm-SelectTimeSlot-RentTime-${index}`)
      input.setAttribute('type', 'radio')
      input.setAttribute('name', 'RentTime')
      input.setAttribute('value', formattedTime)
      input.required = true

      const div = document.createElement('div')
      div.className = 'btn btn-outline-primary btn-block card-input-element timeblock-btn'
      div.textContent = formattedTime

      label.appendChild(input)
      label.appendChild(div)
      timeSlotContainer.appendChild(label)
    })
  }

  // ===================
  // HANDLE AJAX FUNCTIONS
  // ===================

  const stepContextData = []
  $(document).on('shown.bs.modal', '.modal.js-form-xhr', function (e) {
    const $form = $(this).find('form')
    const formData = new FormData($form[0])
    if (formData.get('BomPart') && formData.get('SubscriptionAgendaID')) {
      fetchBomTimes(null, formData.get('BomPart'), formData.get('SubscriptionAgendaID'))
    }

    // ===================
    // Disable ActivityGroupID dropdown when ticket modal is open and selecting a person (cursist) is required.
    // ===================
    if ($('#ticket-modal.show').length) {
      if ($(this).is('.show') && $(this).find('form select[name="PersonID"]').length) {
        $(this).find('form select[name="ActivityGroupID"]').prop('disabled', true)
      } else {
        $(this).find('form select[name="ActivityGroupID"]').prop('disabled', false)
      }
    }
  })
  $(document).on('submit', '.modal.js-form-xhr form', function (e) {
    e.preventDefault()

    const $form = $(this)
    const $modalBody = ($form.find('.modal-body').length > 0) ? $form.find('.modal-body') : $form.closest('.modal-body')

    const formData = new FormData(this)
    let $submit

    // Add all fields to formData if it's empty --- bugfix
    if (!Array.from(formData).length) {
      $form.find('input, select, textarea').each(function () {
        if ($(this).val().length && $(this).val() !== '__new__') {
          formData.append($(this).attr('name'), $(this).val())
        }
      })
    }

    $form.find(':submit').each(function () {
      if (!$submit && $(this).val() === $form.find(`input[name="${$(this).attr('name')}"]`).val()) {
        $submit = $(this)
      }
    })

    if (!$submit) {
      $submit = $form.find(':submit')
    }

    clearAlerts($modalBody)

    if (!$form[0].reportValidity()) {
      $submit.prop('disabled', false)
      return false
    }

    if (formData.get('PickTimeBlockYN') === '1') {
      $form.closest('.modal').modal('hide')

      const tpl = $('#js-tpl-calendar-modal-' + $.escapeSelector(formData.get('PartID'))).html()
      const $modal = $(tpl)

      $('body').append($modal)

      const $targetForm = $modal.find('form')

      for (const entry of formData.entries()) {
        if (!['Quantity', 'PersonID', 'ParentSubscriptionID'].includes(entry[0])) continue
        $targetForm.find(`[name=${entry[0]}]`).val(entry[1])
        if ($targetForm.find(`[data-connect=${entry[0]}]`)) {
          $targetForm.find(`[data-connect=${entry[0]}]`).text(entry[1])
        }
      }

      // Pre-filter ActivityID, so `buildCalendarModal` can disable invalid options
      if (formData.get('ParentSubscriptionID')) {
        $targetForm
          .find('[name=ActivityID]')
          .val(
            $form
              .find(`[name=ParentSubscriptionID] [value="${formData.get('ParentSubscriptionID')}"]`)
              .data('activityId')
          )
      }

      $form.closest('.modal').on('hidden.bs.modal', function () {
        buildCalendarModal($modal)
      })

      return false
    }

    if (formData.get('BomPart') && !formData.get('BomTimeBlockYN')) {
      $form.closest('.modal').modal('hide')
      const tpl = $('#js-tpl-bom-part-modal-' + $.escapeSelector(formData.get('FIELD_ID'))).html()
      const $modal = $(tpl)
      $modal.on('hidden.bs.modal', function (e) {
        e.currentTarget.remove()
      })

      $('body').append($modal)
      const $targetForm = $modal.find('form')
      for (const entry of formData.entries()) {
        if (!['Quantity', 'PersonID', 'ParentSubscriptionID', 'SubscriptionAgendaID', 'PartID', 'BomTimeBlockYN', 'WorkFlowStatus', 'TimeBlockYN'].includes(entry[0])) continue
        $targetForm.find(`[name=${entry[0]}]`).val(entry[1])
        if ($targetForm.find(`[data-connect=${entry[0]}]`)) {
          $targetForm.find(`[data-connect=${entry[0]}]`).text(entry[1])
        }
      }
      const $SubscriptionAgendaDisplay = $('[data-connect="SubscriptionAgendaDisplay"]').text().trim()
      $targetForm.find('[data-connect=SubscriptionAgendaDisplayBOM]').val($SubscriptionAgendaDisplay)
      if ($targetForm.find('[data-connect=SubscriptionAgendaDisplayBOM]')) {
        $targetForm.find('[data-connect=SubscriptionAgendaDisplayBOM]').text('')
        $targetForm.find('[data-connect=SubscriptionAgendaDisplayBOM]').text($SubscriptionAgendaDisplay)
      }

      $form.find(':submit').prop('disabled', false)
      $form.closest('.modal').on('hidden.bs.modal', function () {
        $modal.modal('show')
      })
      // Event listener voor datumveld binnen de nieuwe modal
      if (formData.get('BomTimeBlockYN') === '1') {
        $modal.on('shown.bs.modal', function () {
          const rentDateInput = document.getElementById('ShoppingCartForm-SelectTimeSlot-' + formData.get('PartID') + '-rentDate')
          if (rentDateInput) {
            rentDateInput.addEventListener('change', function (event) {
              const RentDate = event.target.value
              fetchBomTimes(RentDate, formData.get('BomPart'), formData.get('PartID'))
            })
          }
        })
      }

      $modal.on('shown.bs.modal', function () {
        // Ensure modal-open class is present after modal is fully shown
        if (!$('body').hasClass('modal-open')) {
          $('body').addClass('modal-open')
        }
      })

      $modal.modal('show')
      return false
    }

    // Define function in the js-form-xhr element as data-function. Default is addToCart
    const ajaxFunction = $form.closest('.modal.js-form-xhr').attr('data-function') || 'dataduiker/addToCart'

    formData.set('function', ajaxFunction)
    const doReload = !$form.data('skipReload')

    $.ajax(window.ajaxURL, {
      method: 'POST',
      dataType: 'json',
      // NOTE: FullCalendar will use `input[name="function"]` to override the event
      // source URL, causing bugs. So we use a custom implementation of `$.serialize()`
      // for the form data because we don't want to physically add `input[name="function"]`
      // to the DOM
      data: [...formData.entries()]
        .map(e => encodeURIComponent(e[0]) + '=' + encodeURIComponent(e[1]))
        .join('&')
    })
      .done(function (data) {
        const $cartForm = $('body').find('#ticket-modal.show form')

        if ($('body').find('#new-pag-modal.show').length && $('body').find('#ticket-modal.show').length) {
          $cartForm.append($(`<input type="hidden" name="ActivityGroupID" value="${formData.get('ActivityGroupID')}">`))
          $cartForm.find('[type="submit"], select, input').prop('disabled', true)
          $('body').find('#new-pag-modal').modal('hide') // Close the pag modal

          $cartForm.trigger('submit')
          return
        } else if (data && data.success) {
          if (data.redirect) {
            window.location.href = data.redirect
            return
          }

          scrollModalToTop($modalBody)
          addAlertToModalBody($modalBody, data.message, { variant: (data.variant || 'success') })

          if ($modalBody.find('.js-calendar').length > 0) {
            // clear selection
            $modalBody.find('.fc-event').removeClass('active inactive')
            $form.find('[name=SubscriptionAgendaID]').val('')
            const $dateDisplay = $form.find('[data-connect=SubscriptionAgendaDisplay]')
            $dateDisplay.text($dateDisplay.data('original-text')).addClass('text-muted')
            $form.find(':submit').prop('disabled', true)

            // re-fetch
            if ($modalBody.find('.js-calendar').data('fc.calendar')) {
              $modalBody.find('.js-calendar').data('fc.calendar').refetchEvents()
              $form.find('button[name="SUBMIT_SECONDARY"').show()
              $form.find('button[name="SUBMIT_TERTIARY"').hide()
            }
          } else {
            // No calendar, so no selection is required
            $form.find(':submit').prop('disabled', false)
          }

          // Update information
          if (data.context) {
            const { SubscriptionAgenda, Subscription } = data.context
            if (SubscriptionAgenda) {
              $modalBody.find('[data-rel=occupation]').text(SubscriptionAgenda.CurrentEntryQuantity || '0')
            }
            if (Subscription && Subscription.Quantity) {
              $modalBody.find('[data-rel=remainingCredit]').text(Subscription.Quantity - Subscription.QuantityUsed)
            }
          }
        }

        if (data && data.redirect && doReload) {
          if (data.redirect.startsWith('#')) {
            window.location.replace(data.redirect)
          } else {
            window.location.href = data.redirect
            return
          }
        }

        if ($cartForm.length) {
          $cartForm.find('[type="submit"], select, input').prop('disabled', false)
        }

        if (doReload) {
          $form.closest('.modal').modal('hide')

          $(document).scrollTop(0)

          const newHref = window.location.href.split('?')[0]

          if (window.location.href.includes('?')) {
            window.location.href = newHref
          } else {
            window.location.reload()
          }
        }
      })
      .fail(function (res) {
        $submit.prop('disabled', false)

        scrollModalToTop($modalBody)

        let messages = []

        if (typeof res.responseJSON === 'object') {
          messages = Object.values(res.responseJSON)
        } else {
          messages.push(res.responseText)
        }

        $.each(messages, function (i, message) {
          addAlertToModalBody($modalBody, message, { variant: 'danger' })
        })
      })
  })

  const addAlertToModalBody = function ($modalBody, message, options = {}) {
    const $alert = $(`<div class="alert alert-${options.variant || 'danger'} alert-dismissible fade show" role="alert">
  <button type="button" class="close" data-dismiss="alert" aria-label="Close">
    <span aria-hidden="true">&times;</span>
  </button>
</div>`)
    $alert.prepend($('<span>' + message + '</span>'))
    $modalBody.prepend($alert)
  }

  const clearAlerts = function ($modalBody) {
    $modalBody.find('.alert-dismissible').alert('close')
  }

  const scrollModalToTop = function ($modalBody) {
    const $modalDialog = $modalBody.closest('.modal-dialog')

    if ($modalDialog.hasClass('modal-dialog-scrollable')) {
      $modalBody.animate({ scrollTop: 0 }, 500)
    } else {
      $modalBody.closest('.modal').animate({ scrollTop: 0 }, 500)
    }
  }

  $(document).on('click', '.modal.js-form-xhr form :submit', function (e) {
    e.preventDefault()

    const $submit = $(this)
    const $form = $submit.closest('form')
    const formData = new FormData(e.target.closest('form'))

    if (formData.get('PositionNumber')) {
      saveStepData(formData.get('PositionNumber'), formData.entries())
    }

    $submit.prop('disabled', true)

    if (stepContextData.length > 0) {
      $form.find('[name=BOMPositionContext]').val(JSON.stringify({ ...stepContextData }))
    }

    if ($form.find(`input[name="${$submit.attr('name')}"]`).length > 0) {
      $form.find(`input[name="${$submit.attr('name')}"]`).val($submit.val())
    } else {
      $form.prepend($(`<input type="hidden" name="${$submit.attr('name')}" value="${$submit.val()}">`))
    }

    $form.submit()
  })

  // ===================
  // RESEND INVOICE
  // ===================
  $('.js-resend-invoice').click(function () {
    const $this = $(this)
    $this.removeClass('text-info text-danger text-success').addClass('text-muted')
    $.post({
      url: window.ajaxURL,
      type: 'POST',
      data: {
        function: 'dataduiker/resendInvoiceConfirmation',
        invoice: $this.data('invoice')
      }
    }).done(function (response) {
      response = JSON.parse(response)
      $this.removeClass('text-muted').addClass(response.success ? 'text-success' : 'text-danger')
    })
  })

  function saveStepData (stepIndex, formEntries) {
    stepContextData[stepIndex] = getFormValuesAsJson(formEntries)
  }

  function getFormValuesAsJson (formEntries) {
    const jsonObject = {}

    // Iterate through FormData entries and add them to the jsonObject
    for (const [key, value] of formEntries) {
      if (!['Quantity', 'RentTime', 'RentDate', 'StartDate', 'ParentSubscriptionID', 'SubscriptionAgendaID', 'PartID'].includes(key)) continue
      jsonObject[key] = value
    }

    return jsonObject
  }

  function refreshPersonGroups ($form, params = {}, preferredValue = null) {
    params = Object.assign({
      BuyableYN: false,
      SubscribeYN: false
    }, params)

    const useSpinner = false // not compatible with full-width fields

    const $groupField = $form.find('[name=ActivityGroupID]')

    // Add loading state
    $groupField.prop('disabled', true)
    const $spinner = $('<i class="fa fa-fw fa-circle-notch fa-spin fa-lg ml-2 text-info" style="display: none"></i>')
    if (useSpinner) {
      $groupField.after($spinner)
      $spinner.fadeIn(250)
    }

    $.get({
      url: window.ajaxURL,
      data: {
        function: 'student-tracking/getPersonGroups',
        ActivityID: $('.modal-title').attr('id'),
        PartID: $form.data('partid'),
        ...params
      }
    }).done(function (response) {
      response = JSON.parse(response)

      // Keep descriptive options (with empty "value" attribute)
      const optionsToKeep = $groupField.find('option').filter((_i, option) => !$(option).val())
      $groupField.empty().append(optionsToKeep)

      // Map to:
      //  {
      //    "Zeilen": [...items],
      //    "__other": [...items]
      //  }
      const optGroups = (response.items || []).reduce(
        (result, item) => {
          let label = '__other'
          const labelArr = []
          if (item.Activity) {
            labelArr.push(item.Activity.Name)
          } else if (item['Activity.Name']) {
            labelArr.push(item['Activity.Name'])
          }
          if (labelArr.length > 0) {
            if (item.Warehouse) {
              labelArr.push(item.Warehouse.Name)
            }
            label = labelArr.join(' - ')
          }
          if (!result[label]) result[label] = []
          result[label].push(item)
          return result
        },
        {}
      )

      // Convert mapped response to DOM nodes
      Object.keys(optGroups).forEach(label => {
        let $target = $groupField
        if (label !== '__other') {
          $target = $(`<optgroup label="${label}"></optgroup>`)
          $groupField.append($target)
        }

        optGroups[label].forEach(item => {
          const $time = item.WaitingTimeExpectation ? ' (' + item.WaitingTimeExpectation + ')' : ''
          const $option = $(`<option value="${item.ActivityGroupID}" data-warehouse="${item.WarehouseID}">${item._attributes?.displayText || item.Name + $time} </option>`)
          if (item._attributes?.disabled) {
            $option.prop('disabled', true)
          }

          // Set data attributes
          const data = item._attributes?.data || {}
          Object.keys(data).forEach(d => $option.data(d, data[d]))

          $target.append($option)
        })
      })

      // In the right context, add a "__new__" option
      if (params.PersonID !== '__new__' && !params.SubscribeYN) {
        $groupField.append($('<option value="__new__">Nieuwe inschrijving...</option>'))
      }

      // Auto-select if single response item or when preferred value is provided
      if (response.items.length === 1) {
        $groupField.val(response.items[0].ActivityGroupID)
      } else if (preferredValue && response.items.map(a => a.ActivityGroupID).includes(preferredValue)) {
        $groupField.val(preferredValue)
      }

      $groupField.trigger('pagmodalload')

      // Remove loading state
      if (useSpinner) {
        $spinner.fadeOut(250, function () { $(this).remove() })
      }
      $groupField.prop('disabled', false)
    })
  }

  // ===================
  // EVENT LISTENERS
  // ===================

  $('.custom-file-upload').each(function () {
    const self = $(this)
    $(this).on('change', function () {
      if (this.files[0].size > 2097152) {
        alert('Bestand te groot!')
        this.value = ''
      } else {
        $(this).siblings('.custom-file-name').text(this.files[0].name)
        const oFReader = new FileReader()
        oFReader.readAsDataURL(this.files[0])

        oFReader.onload = function (oFREvent) {
          self.closest('.form-row').find('.custom-file-image-display').attr('src', oFREvent.target.result)
        }
      }
    })
  })

  $('#daterange-append').click(function () {
    $(this).siblings('#daterangeinput').focus()
  })

  $('body')
    .on('change', '.js-fetch-groups', function () {
      refreshPersonGroups($(this).closest('form'), { PersonID: $(this).val(), BuyableYN: true })
    })
    .on('change initselectfilter', '[name=WarehouseID]', function () {
      const $groupField = $(this)
      const $groupFieldActivityGroupForm = $groupField.closest('form').find('[name^=ActivityGroupID]')
      // reset select to placeholder selection
      $groupFieldActivityGroupForm.val('')
      // create a element to store options in if it does not exist
      if ($('#storeElement').length === 0) {
        const storeElement = $('<div id="storeElement" class="d-none">')
        storeElement.appendTo('body')
      }

      const $storeElement = $('#storeElement')
      // move all curren options to the store element
      $groupField.closest('form').find('[name^=ActivityGroupID] > optgroup').each(function () {
        $(this).appendTo('#storeElement')
      })
      // if reset to placeholder selection, show all options
      if ($(this).val() === '') {
        $storeElement.find('optgroup').each(function () {
          $(this).appendTo($groupFieldActivityGroupForm)
        })
      } else {
        $storeElement.find('option').each(function () {
          if (!$(this).is(':first-child')) {
            // we only parse the first child to move the entire optgroup, so we can skip the rest
            return
          }
          if ($(this).attr('data-warehouse') === $groupField.val() || $(this).val() === '') {
            $(this).parent('optgroup').appendTo($groupFieldActivityGroupForm)
          }
        })
      }
    })
    .on('change pagmodalload', '.js-select-waiting-list', function () {
      const $groupField = $(this)
      const availabilityField = $groupField.closest('form').find('[name^=AvailabilityID]')
      const availabilityFieldContainer = availabilityField.closest('.availability-select').first()

      $groupField.prop('disabled', true) // Wait till we have a response
      availabilityFieldContainer.find('input[name^=AvailabilityID]').prop('checked', false) // Uncheck all options when changing group.

      $.getJSON({
        url: window.ajaxURL,
        data: {
          function: 'student-tracking/getWaitingListPrefDates',
          ActivityGroupID: $(this).val()
        }
      })
        .done(function ({ AvailabilityID }) {
          // Show results or hide if we have no results
          if (AvailabilityID.length > 0) {
            if (!availabilityFieldContainer.is(':visible')) {
              availabilityFieldContainer.slideDown()
            }
          } else {
            availabilityFieldContainer.slideUp()
          }

          availabilityFieldContainer.find('input[name^=AvailabilityID]').closest('.custom-checkbox').show() // Show all checkboxes.
          let allHidden = true
          availabilityFieldContainer.find('input[name^=AvailabilityID]').each(function () {
            const checkbox = $(this).closest('.custom-checkbox')

            if (!AvailabilityID.includes($(this).val())) {
              checkbox.hide() // Now hide which one dont match.
            } else {
              allHidden = false
            }
          })

          if (allHidden) {
            availabilityFieldContainer.slideUp()
          }
        }).catch(function () {
          availabilityFieldContainer.slideUp() // Dont show when we have an error.
        }).then(function () {
          $groupField.prop('disabled', false)
        })

      const $alert = $groupField.closest('form').find('.js-alert-toggleable')
      if ($groupField.find(':selected').data('part')) {
        $alert.show()
      } else {
        $alert.hide()
      }
      const $alertRetention = $groupField.closest('form').find('.js-alert-retention')
      if ($groupField.find(':selected').data('retention')) {
        $alertRetention.show()
      } else {
        $alertRetention.hide()
      }
    })

    .on('change', '#SharedSubscriptionPersonForm-Insert-PersonID', function () {
      if (this.value !== 'add') {
        $(this).closest('form').find('#accountFields').hide()
      } else {
        $(this).closest('form').find('#accountFields').show()
      }
    })
    // ===================
    // Redirect creating new person when selecting 'Nieuwe cursist...'
    // ===================
    .on('change', '#ticket-modal form select[name="PersonID"]', function () {
      if ($(this).val() === '__new__') {
        $(this).closest('form').find('button[type="submit"]').prop('disabled', true)
        window.location = '/mijn-cursussen/cursist-aanmelden'
      } else {
        $(this).closest('form').find('select[name="ActivityGroupID"]').prop('disabled', false)
      }
    })
    // ===================
    // Trigger group modal from ticket modal
    // ===================
    .on('change', '#ticket-modal form select[name="ActivityGroupID"]', function () {
      const form = $(this).closest('form')

      const payload = {
        PartID: form.data('partid')
      }

      // Add CustomerID to payload if it exists
      if (form.find('input[name="CustomerID"]')) {
        payload.CustomerID = form.find('input[name="CustomerID"]').val()
      }

      // Add PersonID to payload if it exists
      if (form.find('select[name="PersonID"]').val()) {
        payload.PersonID = form.find('select[name="PersonID"]').val()
      }

      if ($(this).val() === '__new__') {
        buildNewGroupModal('Part:' + payload.PartID, payload, false, true).then(() => {
          // This means signup for a (new) group didnt succeed. Set back the 'Group' dropdown to null.
          if (!$('body').find('#ticket-modal form input[name="ActivityGroupID"]').length) {
            $('body').find('#ticket-modal form select[name="ActivityGroupID"]').val(null)
          }
        })
      }
    })

  $('[data-accountFields]').hide()

  $(window).on('load', function () {
    $('[name=WarehouseID]').trigger('initselectfilter')
  })

  $('#my-account-collapse')
    .on('hide.bs.collapse', function () {
      $('.js-collapse-chevron').removeClass('fa-angle-up').addClass('fa-angle-down')
    })
    .on('show.bs.collapse', function () {
      $('.js-collapse-chevron').removeClass('fa-angle-down').addClass('fa-angle-up')
    })

  const radioInputs = document.querySelectorAll('input[type=\'radio\'][name=\'PayProviderID\']')
  const referenceContainer = document.getElementById('referenceContainer')

  // If only one payment provider is available, check it by default.
  if (radioInputs.length === 1) {
    radioInputs[0].checked = true
  }

  radioInputs.forEach(radioInput => {
    radioInput.addEventListener('change', function () {
      if (radioInput.checked && radioInput.value === 'INVOICE') {
        referenceContainer.classList.remove('d-none')
      } else {
        referenceContainer.classList.add('d-none')
      }
    })
  })

  // ===================
  // STORNO PAYMENT MODAL
  // ===================
  $('.js-show-storno-payment-modal').removeClass('disabled').on('click', function (e) {
    e.preventDefault()

    const tpl = $('#js-tpl-storno-payment-modal-' + $.escapeSelector($(this).data('cash-collection'))).html()
    const $modal = $(tpl)

    $('body').append($modal)

    $modal.modal()

    $modal.find('[data-toggle=popover]').popover()

    $modal.on('hidden.bs.modal', function (e) {
      $(this).data('bs.modal', null)
      $modal.remove()
    })
  })
})
